import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import React__default from 'react';

const useStyles = makeStyles({
  iconContainer: {
    display: "flex",
    position: "relative",
    width: "100%"
  },
  arrow1: {
    right: "6px",
    position: "absolute"
  }
});
const DoubleArrowRight = () => {
  const classes = useStyles();
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.iconContainer }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.arrow1 }, /* @__PURE__ */ React__default.createElement(ArrowForwardIosIcon, { style: { fontSize: "12px" } })), /* @__PURE__ */ React__default.createElement(Box, null, /* @__PURE__ */ React__default.createElement(ArrowForwardIosIcon, { style: { fontSize: "12px" } })));
};

export { DoubleArrowRight as default };
//# sourceMappingURL=DoubleArrowRight.esm.js.map
